module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_14.513c7612.png";